package gr.tech.site.styles

import com.varabyte.kobweb.compose.css.*
import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.css.functions.linearGradient
import com.varabyte.kobweb.compose.css.functions.min
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.silk.components.forms.ButtonStyle
import com.varabyte.kobweb.silk.components.forms.ButtonVars
import com.varabyte.kobweb.silk.components.layout.HorizontalDividerStyle
import com.varabyte.kobweb.silk.init.InitSilk
import com.varabyte.kobweb.silk.init.InitSilkContext
import com.varabyte.kobweb.silk.init.registerStyleBase
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.addVariantBase
import com.varabyte.kobweb.silk.style.base
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.style.layer.SilkLayer
import com.varabyte.kobweb.silk.style.layer.add
import com.varabyte.kobweb.silk.style.selectors.hover
import com.varabyte.kobweb.silk.theme.colors.palette.color
import com.varabyte.kobweb.silk.theme.colors.palette.toPalette
import com.varabyte.kobweb.silk.theme.modifyStyleBase
import org.jetbrains.compose.web.css.*

@InitSilk
fun initSiteStyles(ctx: InitSilkContext) {
    //ctx.stylesheet.cssLayers.add("GlobalCSS", after = SilkLayer.BASE)
    ctx.stylesheet.cssLayers.add("BootstrapCSS", after = SilkLayer.BASE)

    // This site does not need scrolling itself, but this is a good demonstration for how you might enable this in your
    // own site. Note that we only enable smooth scrolling unless the user has requested reduced motion, which is
    // considered a best practice.
    ctx.stylesheet.registerStyle("html") {
        cssRule(CSSMediaQuery.MediaFeature("prefers-reduced-motion", StylePropertyValue("no-preference"))) {
            Modifier.scrollBehavior(ScrollBehavior.Smooth)
        }
    }

    ctx.stylesheet.registerStyleBase("body") {
        Modifier
            .fontFamily(
                "Gotham", "-apple-system", "system-ui", "sans-serif"
            )
            .fontWeight(400)
            .fontSize(18.px)
            .lineHeight(1.5)
    }

    // Silk dividers only extend 90% by default; we want full width dividers in our site
    ctx.theme.modifyStyleBase(HorizontalDividerStyle) {
        Modifier.fillMaxWidth().borderTop(1.px, LineStyle.Solid, Colors.Black)
    }
}


/* ------- OWEN CUSTOM ADDED -----------*/

fun Modifier.wideCappedWidth(): Modifier {
    return this
        .width(min(1144.px, 100.percent - 2.cssRem))
}


val BlogCardHoverStyle = CssStyle {
    base {
        Modifier
            .backgroundColor(Theme.LightGray.rgb)
            .borderRadius(8.px)
            .transition(Transition.all(250.ms))
    }
    hover {
        Modifier
            .boxShadow(BoxShadow.of(
                offsetX = 0.px,
                offsetY = 4.px,
                blurRadius = 12.px,
                spreadRadius = 0.px,
                color = rgba(0, 0, 0, 0.1)
            ))
            .translateY((-2).px)
    }
}

val ButtonHoverGreen = CssStyle {
    base {
        Modifier
            .color(Theme.OverlayGreen.rgb)
            .backgroundColor(Colors.WhiteSmoke)
    }
    hover {
        Modifier
            .color(Colors.WhiteSmoke)
            .backgroundColor(Theme.MediumGreen.rgb)
            .transition(Transition.all(250.ms))
    }
}

val ButtonHoverDarkGreen = CssStyle {
    base {
        Modifier
            .color(Colors.WhiteSmoke)
            .backgroundColor(Theme.MediumGreen.rgb)
    }
    hover {
        Modifier
            .color(Colors.WhiteSmoke)
            .backgroundColor(Theme.DarkGreen.rgb)
            .transition(Transition.all(250.ms))
    }
}

val ButtonHoverMediumGreen = CssStyle {
    base {
        Modifier
            .color(Colors.WhiteSmoke)
            .backgroundColor(Theme.DarkGreen.rgb)
    }
    hover {
        Modifier
            .color(Colors.WhiteSmoke)
            .backgroundColor(Theme.MediumGreen.rgb)
            .transition(Transition.all(250.ms))
    }
}

val ButtonHoverWhite = CssStyle {
    base {
        Modifier
            .color(Colors.WhiteSmoke)
            .backgroundColor(Theme.MediumGreen.rgb)
    }
    hover {
        Modifier
            .color(Theme.MediumGreen.rgb)
            .backgroundColor(Colors.WhiteSmoke)
            .transition(Transition.all(250.ms))
    }
}

val NavContactHeaderTextStyle = CssStyle {
    base {
        Modifier
            .fontSize(1.cssRem)
            .color(Colors.White)
            .textDecorationLine(TextDecorationLine.None)
            .margin(0.px)
    }
    Breakpoint.MD {
        Modifier
            .fontSize(1.25.cssRem)
    }
}

val NavLinkHoverStyle = CssStyle {
    base {
        Modifier
            .color(Theme.DarkGreen.rgb)
            .boxShadow(BoxShadow.of(
                offsetX = 0.px,
                offsetY = 0.px,
                blurRadius = 0.px,
                spreadRadius = 0.px,
                color = Theme.MediumGreen.rgb,
                inset = true
            ))
            .transition(
                listOf(
                    Transition.of("color", 300.ms, AnimationTimingFunction.EaseInOut),
                    Transition.of("box-shadow", 300.ms,  AnimationTimingFunction.EaseInOut)
                )
            )
    }
    hover {
        Modifier
            .color(Colors.WhiteSmoke)
            .boxShadow(BoxShadow.of(
                offsetX = 200.px,
                offsetY = 0.px,
                blurRadius = 0.px,
                spreadRadius = 0.px,
                color = Theme.MediumGreen.rgb,
                inset = true
            ))
    }
}

val SocialsIconStyle = CssStyle {
    base {
        Modifier
            .color(Theme.DarkGreen.rgb)
            .transition(Transition.all(250.ms))
    }
    hover {
        Modifier
            .transform {
                translateY((-5).px)
            }
    }
}

val GreenGradientTextStyle = CssStyle.base {
    Modifier
        .background {
            image(
                linearGradient(135.deg) {
                    add(Colors.White, 0.percent)
                    add(Theme.DarkGreen.rgb, 100.percent)
                }
            )
            clip(BackgroundClip.Text)
        }
        .color(Colors.Transparent)
}

/* ------- END OWEN CUSTOM ADDED -----------*/


val HeadlineTextStyle = CssStyle.base {
    Modifier
        .fontSize(3.cssRem)
        .textAlign(TextAlign.Start)
        .lineHeight(1.2) //1.5x doesn't look as good on very large text
}

val SubheadlineTextStyle = CssStyle.base {
    Modifier
        .fontSize(1.cssRem)
        .textAlign(TextAlign.Start)
        .color(colorMode.toPalette().color.toRgb().copyf(alpha = 0.8f))
}

val CircleButtonVariant = ButtonStyle.addVariantBase {
    Modifier.padding(0.px).borderRadius(50.percent)
}

val UncoloredButtonVariant = ButtonStyle.addVariantBase {
    Modifier.setVariable(ButtonVars.BackgroundDefaultColor, Colors.Transparent)
}
